export default function PrimaryButton({ children, className = "", ...props }) {
    return (
        <button
            {...props}
            className={`
                auth-primary-button
                shadow-card 
                min-h-[56px] 
                w-full 
                duration-200 
                text-lg md:text-xl
                p-[12px_24px] 
                font-bold 
                text-surface 
                rounded-[44.85px]
                focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                disabled:cursor-not-allowed disabled:opacity-60
                ${className}
            `}
        >
            {children}
        </button>
    );
}
